import React, { Component } from "react";
import "./EstimatedCost.less";
import { ApiService } from "../../../services/api-service";

class EstimatedCost extends Component {
  constructor(props) {
    super(props);
    this.apiService = new ApiService();
    this.state = {
      isExpanded: false,
      estimatedCost: {
        cotizante: 0,
        cantidadMenor60: 0,
        usuariosMenor60: [],
        menor60: 0,
        cantidadMayor60: 0,
        usuariosMayor60: [],
        mayor60: 0,
        total: 0,
      },
    };

    this.conditions = [
      "Sedes Integrales",
      "Bienestar Integral",
      "Laboratorios Clínicos Propios",
      "Telemedicina",
      "Oficina en línea",
      "Amplia Experiencia",
      "Call Center",
      "Tratamientos preventivos",
      "Asesoría Personalizada",
    ];
  }

  componentDidMount() {
    this.fetchEstimatedCost();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.contributor !== this.props.contributor ||
      prevProps.beneficiaries !== this.props.beneficiaries
    ) {
      this.fetchEstimatedCost();
    }
  }

  createTariffRequestBody = (contributor, beneficiaries) => {
    return {
      Interesado: {
        NumeroDeDocumento: contributor?.documentNumber || "",
        TipoDeDocumento: contributor?.documentType || "",
        Nombre: contributor?.name || "",
        Parentesco: "Titular", // Siempre será "Titular" para el cotizante
        CorreoElectronico: contributor?.email || "",
        NIT: "",
        TipoDocEmpresa: "",
        FechaNacimiento: contributor?.birthDate || "",
        Genero: contributor?.gender || "",
        CajaCompensacion: contributor?.compensationUser ? "Compensar" : "",
        Categoria: contributor?.category || "",
        EPSCompensar: true,
      },
      Beneficiarios: beneficiaries.map((beneficiary) => ({
        NumeroDeDocumento: beneficiary.documentNumber || "",
        TipoDeDocumento: beneficiary.documentType || "",
        Nombre: beneficiary.name || "",
        Parentesco: beneficiary.relation || "",
        CorreoElectronico: "",
        NIT: "",
        TipoDocEmpresa: "",
        FechaNacimiento: beneficiary.birthDate || "",
        Genero: beneficiary.gender || "",
        CajaCompensacion: beneficiary.compensationUser ? "Compensar" : "",
        Categoria: beneficiary.category || "",
        EPSCompensar: true,
      })),
    };
  };

  fetchEstimatedCost = () => {
    const { contributor, beneficiaries } = this.props;

    if (!contributor) return;

    const body = this.createTariffRequestBody(contributor, beneficiaries);

    this.apiService
      .post("ServicioConsorcio.svc/CalcularTarifaMP", body)
      .then((response) => {
        this.setState({
          estimatedCost: {
            cotizante:
              response.UsuarioTotal?.InfoUsuarios?.cotizacionUsuario || 0,
            cantidadMenor60:
              response.UsuariosMenorEdadDefinida?.CantidadUsuarios || 0,
            usuariosMenor60:
              response.UsuariosMenorEdadDefinida?.InfoUsuarios || [],
            menor60: response.UsuariosMenorEdadDefinida?.ValorTotal || 0,
            cantidadMayor60:
              response.UsuariosMayorEdadDefinida?.CantidadUsuarios || 0,
            usuariosMayor60:
              response.UsuariosMayorEdadDefinida?.InfoUsuarios || [],
            mayor60: response.UsuariosMayorEdadDefinida?.ValorTotal || 0,
            total: response.PrecioMensualDesde || 0,
          },
        });
        this.props.onCostChange(response.PrecioMensualDesde);
      })
      .catch((error) => {
        console.error("Error al obtener el costo estimado:", error);
      });
  };

  toggleExpansion = () => {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  };

  render() {
    const { isExpanded, estimatedCost } = this.state;

    return (
      <div className="estimated-cost">
        <h2>Costo estimado en tiempo real</h2>
        <p className="estimated-cost__description">
          <strong>Importante:</strong> Los precios son aproximados y pueden
          variar según validación de los datos suministrados.
        </p>

        <div className="estimated-cost__info">
          <div className="estimated-cost__header">
            <span>Tipo de plan:</span>
            <span className="estimated-cost__plan">{this.props.planType}</span>
          </div>
          <br />
          <div className="estimated-cost__row">
            <div className="estimated-cost__row-description">
              <span className="estimated-cost__count">{estimatedCost.cotizante ? 1 : 0}</span>
              <span>Cotizante</span>
            </div>
            <span className="estimated-cost__price">
              ${estimatedCost.cotizante.toLocaleString()}
            </span>
          </div>
          <div className="estimated-cost__row">
            <div className="estimated-cost__row-description">
              <span className="estimated-cost__count">
                {estimatedCost.cantidadMenor60}
              </span>
              <span>
                Beneficiario <b>menor</b> de 60 años
              </span>
            </div>
            <span className="estimated-cost__price">
              ${estimatedCost.menor60.toLocaleString()}
            </span>
          </div>
          {estimatedCost.usuariosMenor60.map((user, index) => (
            <div key={index} className="estimated-cost__row">
              <div className="estimated-cost__row-description">
                <span className="estimated-cost__icon">
                  <i
                    className="text-purple fa fa-check-circle-o"
                    aria-hidden="true"
                  ></i>
                </span>
                <span>{user.Nombre}</span>
              </div>
              <span className="estimated-cost__price-light">
                ${user.cotizacionUsuario.toLocaleString()}
              </span>
            </div>
          ))}
          <div className="estimated-cost__row">
            <div className="estimated-cost__row-description">
              <span className="estimated-cost__count">
                {estimatedCost.cantidadMayor60}
              </span>
              <span>
                Beneficiario <b>mayor</b> de 60 años
              </span>
            </div>
            <span className="estimated-cost__price">
              ${estimatedCost.mayor60.toLocaleString()}
            </span>
          </div>
          {estimatedCost.usuariosMayor60.map((user, index) => (
            <div key={index} className="estimated-cost__row">
              <div className="estimated-cost__row-description">
                <span className="estimated-cost__icon">
                  <i
                    className="text-purple fa fa-check-circle-o"
                    aria-hidden="true"
                  ></i>
                </span>
                <span>{user.Nombre}</span>
              </div>
              <span className="estimated-cost__price-light">
                ${user.cotizacionUsuario.toLocaleString()}
              </span>
            </div>
          ))}
          <br />
          <div className="estimated-cost__total">
            <strong>Precio mensual desde</strong>
            <h3 className="total-price">
              ${estimatedCost.total.toLocaleString()}
            </h3>
          </div>
        </div>

        <div className="estimated-cost__conditions">
          <div
            className={`estimated-cost__toggle ${isExpanded && "isExpanded"}`}
            onClick={this.toggleExpansion}
          >
            <strong>Condiciones</strong>
            <i className="fa fa-angle-down" aria-hidden="true"></i>
          </div>
          {isExpanded && (
            <div className="estimated-cost__list">
              {this.conditions.map((condition, index) => (
                <span key={index} className="estimated-cost__condition">
                  <i
                    className="text-purple fa fa-check-circle-o"
                    aria-hidden="true"
                  ></i>{" "}
                  {condition}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EstimatedCost;
